import {AuditService} from "../PA.Core/Security/AuditService";
import {AuditUtils, IAuditField} from "../PA.Core/Basic/AuditUtils";
import {ProductConditionTypeBO} from "./ProductConditionTypeBO";

export class ProductConditionTypeBOAudit {

    // Audit Log Service for ProductConditionType

    static async ProductConditionTypeAuditBO(ProductConditionTypeBO: ProductConditionTypeBO): Promise<AuditService> {
        const self = ProductConditionTypeBO
        const auditService = new AuditService(self.dbContext)
        auditService.setReference("ProductConditionType", self.drWB_ProductConditionType.cif.PRD_CNDM_ID)
        // @ts-ignore
        self.deleteKeys = self.deleteKeys || {}
        // @ts-ignore
        let deleteKeys: any = self.deleteKeys

        //Adding new Product Condition Type on screen
        const productConditionTypeParams: IAuditField [] = [
            {fieldName: "CONDITION_TYPE_NAME", realName: "Name", bAllMsg: true},
            {fieldName: "CONDITION_TYPE", realName: "ID"},
            {fieldName: "SOURCE_ID", realName: "Source"},
            {fieldName: "TREE_PATH", realName: "Tree Path"},

        ]


        await AuditUtils.logRecord(auditService, self.drWB_ProductConditionType, productConditionTypeParams,{objectName: 'Product Condition Type', deletedKeys: deleteKeys})

        return auditService
    }

}